import { createFileRoute } from "@tanstack/react-router";

import { enrolmentSearchParamsSchema } from "@/domain/enrolment";
import { EnrolmentsScreen } from "@/interactors/EnrolmentsScreen";
import { headWithCustomTitle, validateRoutePermission } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/enrolments/")({
  component: EnrolmentsScreen,
  beforeLoad: ({ context }) =>
    validateRoutePermission({
      context,
      action: "read",
      subject: "events",
    }),
  validateSearch: enrolmentSearchParamsSchema,
  head: () => headWithCustomTitle("main:enrolments.title"),
});
